import React from 'react';
import {
  Skeleton, Stack, Typography, useMediaQuery,
} from '@mui/material';
import { BackButton, ContextMenuComplete } from '@marageti/z4-lib';
import { Traveler } from '@marageti/z4-sdk/lib/people';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import SubNavigation from '../sub-navigation';
import { TabItem } from '../sub-navigation/types';
import TripRequestChipList from '../chip-list/trip-request';

type ViewProps = {
  countries?: string;
  tripRequest?: TripRequest;
  tabs?: TabItem[];
  traveler?: Traveler;
  contextMenuItems: {
    action: () => void;
    label: string;
  }[]
};

const TripSubNavigationView = ({
  countries = undefined,
  tripRequest = undefined,
  tabs = undefined,
  traveler = undefined,
  contextMenuItems,
}: ViewProps) => {
  const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('desktop'));

  const getMobileProfile = () => ({
    primary: traveler?.fullName ? (
      <Typography
        component="span"
        variant="h3"
        fontWeight="bold"
      >
        {traveler?.fullName}
      </Typography>
    ) : <Skeleton width={250} />,
    secondary: countries || <Skeleton width={100} />,
    decoration: <TripRequestChipList tripRequest={tripRequest} />,
  });
  return (
    <SubNavigation
      profile={isDesktop ? {
        primary: traveler?.fullName ? (
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography
              component="span"
              variant="h3"
              fontWeight="bold"
            >
              {traveler?.fullName}
            </Typography>
            <TripRequestChipList tripRequest={tripRequest} />
          </Stack>
        ) : <Skeleton width={250} />,
        secondary: countries || <Skeleton width={100} />,
      } : getMobileProfile()}
      tabs={tabs}
      startAdornment={(
        <BackButton
          aria-label="back to trip requests"
          defaultPath="/trip-requests/all"
          edge="start"
        />
    )}
      endAdornment={(
        <ContextMenuComplete
          id="cancel-request"
          items={contextMenuItems}
          contextMenuButtonProps={{
            edge: 'end',
          }}
        />
    )}
      sx={{
      // Added because of the AnnouncementBar in /pages/trip-request/layout.tsx
        top: 52,
      }}
    />
  );
};

export default TripSubNavigationView;
